module.exports = __webpack_public_path__ + "img/poster_1.009952a7.png";